/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
import { Grid, Typography } from '@mui/material';
import React from 'react';

export default function StreamSheetPageTitle(props) {
	return (
		<React.Fragment>
			<Grid container spacing={2} key="gridPT">
				<Grid item xs={9} key="title">
					<Typography color="text.primary" variant="h5" sx={{ fontWeight: '500', fontSize: '1.5rem', marginBottom: '15px' }}>
						{props.title}
					</Typography>
				</Grid>
				<Grid sx={{ paddingTop: '5px !important' }} item xs={3} key="ws">
					{props.select ? props.select : null}
				</Grid>
			</Grid>
			<Typography color="text.primary" sx={{ marginBottom: '14px' }} key="typePT">
				{props.subTitle}
			</Typography>
		</React.Fragment>
	);
}
